import axios from 'axios';

/**
 * --------------------------------------------------------------- GET Method
 * 获取项目一级分组列表
 */
export const getBranches = (params) => {
  const { projectId } = params;
  return axios.get(`/api/projects/${projectId}/branches`);
};


/**
 * --------------------------------------------------------------- PATCH Method
 * 更新项目一级分组属性
 */
export const updateBranch = (params) => {
  const { projectId, name, id } = params;
  return axios.patch(`/api/projects/${projectId}/branches/${id}`, { name });
};


/**
 * 更新二级分组
 */
export const updateDepartment = (params) => {
  const { projectId, name, branchId, id } = params;
  return axios.patch(`/api/branches/${branchId}/departments/${id}`, {
    name, projectId, id,
  });
};


/**
 * --------------------------------------------------------------- POST Method
 * 创建项目一级分组
 */
export const createBranch = (params) => {
  const { projectId, name } = params;
  return axios.post(`/api/projects/${projectId}/branches`, { name });
};


/**
 * 创建二级分组
 */
export const createDepartment = (params) => {
  const { projectId, name, branchId } = params;
  return axios.post(`/api/branches/${branchId}/departments`, {
    name, projectId,
  });
};

/**
 * 设置分组设备频率
 */
export const barchUpdateInterval = (params) => {
  const { id, deviceIds, interval } = params;
  return axios.post(`/api/branches/${id}/devices/batch-update-interval`, {
    deviceIds, interval,
  });
};


/**
 * --------------------------------------------------------------- DELETE Method
 * 删除项目一级分组
 */
export const deleteBranch = (params) => {
  const { projectId, id } = params;
  return axios.delete(`/api/projects/${projectId}/branches/${id}`);
};


/**
 * 删除二级分组
 */
export const deleteDepartment = (params) => {
  const { branchId, id } = params;
  return axios.delete(`/api/branches/${branchId}/departments/${id}`);
};

/**
 * 更新分组的排序
 */
export const updateSort = (params) => {
  const { projectId, sortArr, type, BranchId, DepartmentId } = params;
  return axios.patch(`/api/projects/${projectId}/update-branches-sort`, { sortArr, type, BranchId, DepartmentId });
};

